let inited = false

export default function ({ store }) {
  if (inited) return
  inited = true
  store.dispatch('initWallet', false) // don't show modal
}
